import { Flex } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'

/**
 * The list-page shell: a full-height frame that holds a floating Page panel
 * (and optionally its detail Outlet) on the gray dashboard backdrop.
 *
 * Fills its parent via height: 100%. The layout content region already reserves
 * the top/bottom PANEL_GUTTER inset (see Layout.tsx), so the panel floats clear
 * of the viewport edges without any viewport-relative units or sticky
 * positioning. Kept as one component so every list page stays in sync instead
 * of repeating the frame per file.
 */
export const StickyPanelFrame: FC<{
  children: ReactNode
  'data-testid'?: string
}> = ({ children, ...flexProps }) => (
  <Flex height="100%" {...flexProps}>
    {children}
  </Flex>
)
